export const zh: Record<string, string> = {
  app_subtitle: '根据你的时间和预算，寻找愿望单中下一个该玩的游戏。',
  steam_id_placeholder: '输入 Steam64 ID (例: 76561198012345678)',
  fetch_wishlist: '获取愿望单',
  landing_help: '你的 Steam 资料和愿望单必须为<strong>公开</strong>。可以在 <a href="https://steamid.io" target="_blank" rel="noopener">steamid.io</a> 查询。',
  landing_disclaimer: '这是一个粉丝自制项目，与 <a href="https://store.steampowered.com" target="_blank" rel="noopener">Valve</a>、<a href="https://www.gog.com" target="_blank" rel="noopener">GOG</a> 或 <a href="https://howlongtobeat.com" target="_blank" rel="noopener">HowLongToBeat</a> 无关。数据仅存储在本地。<a href="https://github.com/t0mg/howlong">源码见 GitHub</a>。',
  loading_games_enriched: '已处理 {count} / {total} 个游戏 ({percent}%)',
  loading_throttled_title: 'Steam 限制了请求',
  loading_waiting: '等待中 {time}...',
  loading_stop: '停止并显示结果',
  loading_stopping: '正在停止并准备结果...',
  loading_fetching_appid: '获取愿望单游戏列表...',
  loading_fetching_prices: '获取游戏价格...',
  loading_fetching_details: '获取游戏详情...',
  loading_fetching_details_count: '获取 {count} 个游戏的详情...',
  loading_enriching: '正在获取 HowLongToBeat 数据...',
  loading_enriching_gog: '正在获取 GOG 数据...',
  error_wishlist_private: '愿望单为空或已设置为私密。',
  error_no_details: '无法获取愿望单游戏的详情。',
  error_unexpected: '发生未知错误。',
  error_try_again: '重试',
  dashboard_change_id: '← 更改 Steam ID',
  dashboard_lucky: '手气不错',
  dashboard_insights: '分析',
  dashboard_filter_label: '类别筛选:',
  dashboard_filter_all: '所有类别',
  dashboard_sort_label: '排序规则:',
  dashboard_match_info: '已找到 {found} / {total} 的通关时间',
  dashboard_hltb_warning: '⚠️ 因服务器错误，部分游戏时长未能获取。',
  lucky_title: '手气不错',
  lucky_desc: '不知道玩什么？让命运帮你决定。',
  lucky_too_long: '太长了',
  lucky_not_in_mood: '换个口味',
  lucky_too_expensive: '太贵了',
  lucky_ok: '关闭',
  lucky_empty: '抱歉，没有更多建议了！',
  stats_games: '游戏总数',
  stats_main: '主线剧情',
  stats_main_extra: '主线+支线',
  stats_completionist: '完美收集',
  stats_value: '总价值',
  stats_savings: '折扣节省',
  sort_priority: '优先级',
  sort_dateAdded: '添加日期',
  sort_name: '名称',
  sort_hltbMain: '时间 (主线)',
  sort_hltbMainExtra: '时间 (主线+)',
  sort_hltbCompletionist: '时间 (全收集)',
  sort_priceFinal: '价格',
  sort_discountPercent: '折扣',
  settings_title: '设置',
  settings_desc: '管理应用程序首选项和本地缓存。',
  settings_region_label: 'Steam 商店地区',
  settings_region_desc: '选择所在地区以获取准确价格。',
  settings_lang_label: '界面语言',
  settings_lang_desc: '选择你在应用中的语言。',
  settings_clear_hltb_label: '清除 HLTB 数据',
  settings_clear_hltb_desc: '强制重新获取游戏时长。',
  settings_clear_hltb_btn: '清除 HLTB',
  settings_cleared: '已清除！',
  settings_clear_steam_label: '清除 Steam 数据',
  settings_clear_steam_desc: '清除 Steam 本地缓存信息。',
  settings_clear_steam_btn: '清除 Steam',
  settings_clear_gog_label: '清除 GOG 数据',
  settings_clear_gog_desc: '删除缓存的 GOG 元数据和价格。',
  settings_clear_gog_btn: '清除 GOG',
  settings_clear_hidden_label: '清除已隐藏的游戏',
  settings_clear_hidden_desc: '取消隐藏所有之前被隐藏的游戏。',
  settings_clear_hidden_btn: '清除',
  settings_hard_reset_label: '应用重置',
  settings_hard_reset_desc: '注销缓存机制并彻底清除所有数据。',
  settings_hard_reset_btn: '完全重置',
  settings_hard_reset_confirm: '确定要清除所有数据记录吗？',
  settings_close: '关闭',
  insights_title: '数据分析',
  insights_desc: '通过数据分析你目前的愿望单结构。',
  insights_avg_price_hr: '平均价格/小时',
  insights_oldest_entry: '最早添加',
  insights_top_genre: '最常出现类型',
  insights_total_story: '总计主线时长',
  insights_chart_duration: '时长分布 (小时)',
  insights_chart_price: '价格分布 ({currency})',
  insights_chart_genre: '类型比重',
  insights_chart_year: '愿望单增长时间轴',
  insights_chart_store: '最佳价格: Steam vs GOG',
  game_coming_soon: '即将推出',
  game_demo: '试玩版',
  game_demo_avail: '有试玩',
  game_added: '已添加 {date}',
  game_free: '免费',
  game_unavailable: '不可购买',
  game_cached: '(缓存)',
  game_price_na: '价格未知',
  game_no_hltb: '无时长记录',
  game_hltb_pending: '查询中...',
  game_link_steam: 'Steam',
  game_link_hltb: 'HLTB',
  game_link_gog: 'GOG',
  dashboard_filter_hidden: '已隐藏的游戏',
  game_link_hide: '隐藏',
  game_link_unhide: '取消隐藏',
  hide_confirm_title: '隐藏游戏',
  hide_confirm_desc: '确定要隐藏这个游戏吗？它将从列表中移除，但仍会被系统跟踪。',
  hide_confirm_btn: '隐藏',
  hide_cancel_btn: '取消',
};
